import { render } from "./StockLevelMessage.vue?vue&type=template&id=203a5ab8&scoped=true"
import script from "./StockLevelMessage.vue?vue&type=script&lang=js"
export * from "./StockLevelMessage.vue?vue&type=script&lang=js"

import "./StockLevelMessage.vue?vue&type=style&index=0&id=203a5ab8&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/src/Microfrontends/devices/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-203a5ab8"]])

export default __exports__